import { useState } from 'react';
import {
    ApiBlockListModel,
    CollectiveAgreementContractElementElementModel
} from "@shared/integrations/umbraco-taf-delivery-api/models";
import ContractFileLink from "@my-pages/components/ContractFileLink.tsx";

interface IContracts {
    content: CollectiveAgreementContractElementElementModel;
    settings: any;
}

interface IContractListProps {
    contracts?: ApiBlockListModel;
}

const ContractList = ({ contracts }: IContractListProps) => {
    const [filter, setFilter] = useState<string>();
    const contractsList = contracts?.items ? (contracts.items as IContracts[]) : ([] as IContracts[]);
    const items = filter ? contractsList?.filter((item) => item.content?.properties?.title?.toLowerCase()?.includes(filter.toLowerCase())) : contractsList;
    return (
        <>
            <div className='search-box mb-4'>
                <svg
                    className='search-box-icon'
                    width='20'
                    height='20'
                    viewBox='0 0 40 40'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        d='M24.828 31.657a16.76 16.76 0 0 1-7.992 2.015C7.538 33.672 0 26.134 0 16.836 0 7.538 7.538 0 16.836 0c9.298 0 16.836 7.538 16.836 16.836 0 3.22-.905 6.23-2.475 8.79.288.18.56.395.81.645l5.985 5.986A4.54 4.54 0 0 1 38 38.673a4.535 4.535 0 0 1-6.417-.007l-5.986-5.986a4.545 4.545 0 0 1-.77-1.023zm-7.992-4.046c5.95 0 10.775-4.823 10.775-10.774 0-5.95-4.823-10.775-10.774-10.775-5.95 0-10.775 4.825-10.775 10.776 0 5.95 4.825 10.775 10.776 10.775z'
                        fillRule='evenodd'
                    ></path>
                </svg>
                <input
                    id='contractFilter'
                    className='search-box-input'
                    name='contractFilter'
                    type='text'
                    placeholder='Sök efter avtal...'
                    onChange={(event) => setFilter(event.target.value)}
                />
            </div>
            <div className='contracts-list'>
                <div className='contracts-list-items'>
                    {items && items.length > 0 ? (
                        items.map((item) => {
                            const content = item.content as CollectiveAgreementContractElementElementModel;
                            return (
                                <ContractFileLink
                                    key={content.id}
                                    title={content?.properties?.title}
                                    contract={content?.properties?.contract}
                                    validFrom={content?.properties?.validFrom}
                                    validTo={content?.properties?.validTo}
                                />
                            );
                        })
                    ) : (
                        <p>Inga avtal hittades</p>
                    )}
                </div>
            </div>
        </>
    );
};

export default ContractList;
